// extracted by mini-css-extract-plugin
export default {"register-button":"CsoResult_register-button__3DK+2","register-button--registered":"CsoResult_register-button--registered__tCQrN"};